<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            @change="datePickerChange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetHe_FoodMoonPersonList"
            >查询</el-button
          >
          <el-button type="goon" @click="onClickOpen">导出</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <div style="font-size: 16px">出勤人数总计：{{ AllPeople }}</div>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
        :span-method="objectSpanMethod"
        :cell-class-name="tableRowClassName"
        @cell-mouse-leave="cellMouseLeave"
        @cell-mouse-enter="cellMouseEnter"
      >
        <el-table-column prop="ClassName" label="班级" align="center">
        </el-table-column>
        <el-table-column prop="DateTime" label="时段" align="center">
        </el-table-column>
        <el-table-column label="1" align="center" prop="Count1">
        </el-table-column>
        <el-table-column label="2" align="center" prop="Count2">
        </el-table-column>
        <el-table-column label="3" align="center" prop="Count3">
        </el-table-column>
        <el-table-column label="4" align="center" prop="Count4">
        </el-table-column>
        <el-table-column label="5" align="center" prop="Count5">
        </el-table-column>
        <el-table-column label="6" align="center" prop="Count6">
        </el-table-column>
        <el-table-column label="7" align="center" prop="Count7">
        </el-table-column>
        <el-table-column label="8" align="center" prop="Count8">
        </el-table-column>
        <el-table-column label="9" align="center" prop="Count9">
        </el-table-column>
        <el-table-column label="10" align="center" prop="Count10">
        </el-table-column>
        <el-table-column label="11" align="center" prop="Count11">
        </el-table-column>
        <el-table-column label="12" align="center" prop="Count12">
        </el-table-column>
        <el-table-column label="13" align="center" prop="Count13">
        </el-table-column>
        <el-table-column label="14" align="center" prop="Count14">
        </el-table-column>
        <el-table-column label="15" align="center" prop="Count15">
        </el-table-column>
        <el-table-column label="16" align="center" prop="Count16">
        </el-table-column>
        <el-table-column label="17" align="center" prop="Count17">
        </el-table-column>
        <el-table-column label="18" align="center" prop="Count18">
        </el-table-column>
        <el-table-column label="19" align="center" prop="Count19">
        </el-table-column>
        <el-table-column label="20" align="center" prop="Count20">
        </el-table-column>
        <el-table-column label="21" align="center" prop="Count21">
        </el-table-column>
        <el-table-column label="22" align="center" prop="Count22">
        </el-table-column>
        <el-table-column label="23" align="center" prop="Count23">
        </el-table-column>
        <el-table-column label="24" align="center" prop="Count24">
        </el-table-column>
        <el-table-column label="25" align="center" prop="Count25">
        </el-table-column>
        <el-table-column label="26" align="center" prop="Count26">
        </el-table-column>
        <el-table-column label="27" align="center" prop="Count27">
        </el-table-column>
        <el-table-column label="28" align="center" prop="Count28">
        </el-table-column>
        <el-table-column label="29" align="center" prop="Count29">
        </el-table-column>
        <el-table-column label="30" align="center" prop="Count30">
        </el-table-column>
        <el-table-column label="31" align="center" prop="Count31">
        </el-table-column>
        <el-table-column prop="AttendanceCount" label="出勤人数" align="center">
        </el-table-column>
        <el-table-column prop="ShouldCount" label="应出勤人数" align="center">
        </el-table-column>
        <el-table-column prop="Rate" label="出勤率" align="center">
        </el-table-column>
        <!-- <el-table-column prop="AttendanceCount" label="合计" align="center">
        </el-table-column> -->
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { GetHe_FoodMoonPersonList } from "../../../api/api";
import {
  getMonthStartDate,
  getMonthEndDate,
} from "../../../../util/otherRenders";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      starttime: [],
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth()
            );
          } else {
            return false;
          }
        },
      },
      userInfo: {},
      rowIndex: "-1",
      OrderIndexArr: [],
      hoverOrderArr: [],
      spanArr: [], //二维数组，用于存放单元格合并规则
      position: 0, //用于存储相同项的开始index
      AllPeople: 0,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();

    await this.GetHe_FoodMoonPersonList();
  },
  methods: {
    // 导出
    async onClickOpen() {
      window.open(
        `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetHe_FoodMoonPersonList?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        "_brank"
      );
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    //表格单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 1; i++) {
        if (columnIndex == i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;

          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    // 合并单元格
    tableRowClassName({ row, rowIndex }) {
      let arr = this.hoverOrderArr;
      for (let i = 0; i < arr.length; i++) {
        if (rowIndex == arr[i]) {
          return "hovered-row";
        }
      }
    },

    cellMouseLeave(row, column, cell, event) {
      this.rowIndex = "-1";
      this.hoverOrderArr = [];
    },
    cellMouseEnter(row, column, cell, event) {
      this.rowIndex = row.rowIndex;
      this.hoverOrderArr = [];
      this.OrderIndexArr.forEach((element) => {
        if (element.indexOf(this.rowIndex) >= 0) {
          this.hoverOrderArr = element;
        }
      });
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    async GetHe_FoodMoonPersonList() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetHe_FoodMoonPersonList(params);
      if (res.data.success) {
        this.AllPeople = res.data.response.AllPeople;
        this.tableData = res.data.response.Food_ClassPersonInfos;
        this.rowspan(0, "ClassName");
      } else {
        this.tableData = [];
      }
    },
    datePickerChange(e) {},
    async getNowTime() {
      this.starttime.push(getMonthStartDate());
      this.starttime.push(getMonthEndDate());
    },

    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>